export const courses = [
  // {
  //   title: "Advanced React Patterns",
  //   status: "Enrolled",
  //   date: "Oct 28, 2025",
  //   progress: 0,
  //   hasProgress: false,
  // },
  // {
  //   title: "Leadership & Communication",
  //   status: "Enrolled",
  //   date: "Nov 5, 2025",
  //   progress: 0,
  //   hasProgress: false,
  // },
  // {
  //   title: "Cybersecurity Essentials",
  //   status: "Enrolled",
  //   date: "Nov 15, 2025",
  //   progress: 0,
  //   hasProgress: false,
  // },
];

